import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../locales/en/translation.json";
import arTranslation from "../locales/ar/translation.json";

export const resources = {
  en: { translation: enTranslation },
  ar: { translation: arTranslation },
} as const;

export function initI18n(defaultLang: "en" | "ar" = "en") {
  const savedLang = (typeof window !== "undefined" ? localStorage.getItem("language") : null) as
    "en" | "ar" | null;
  const initialLang = savedLang || defaultLang;

  i18next.use(initReactI18next).init({
    resources,
    lng: initialLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  // Sync document dir attribute for RTL
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", initialLang === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", initialLang);
  }

  return i18next;
}

/** Toggle language at runtime */
export function switchLanguage(lang: "en" | "ar") {
  i18next.changeLanguage(lang);
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lang);
  }
  if (typeof window !== "undefined") {
    localStorage.setItem("language", lang);
  }
}

export { i18next };
